(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-work-videos"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-custom-work-videos]').forEach((section) => {
    const track = section.querySelector('[data-custom-work-videos-track]');
    const previous = section.querySelector('[data-custom-work-videos-previous]');
    const next = section.querySelector('[data-custom-work-videos-next]');

    if (!track) return;

    const scroll = (direction) => {
      const item = track.querySelector('.custom-work-videos__item');
      const gap = Number.parseFloat(window.getComputedStyle(track).gap) || 0;
      const distance = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };

    previous?.addEventListener('click', () => scroll(-1));
    next?.addEventListener('click', () => scroll(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-editorial"]) return;
  try {
    
  if (!customElements.get('blog-listing')) {
    customElements.define('blog-listing', class BlogListing extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-load-more]');
        if (this.button) this.button.addEventListener('click', () => this.loadNextPage());
      }
      async loadNextPage() {
        if (!this.button || this.button.getAttribute('aria-busy') === 'true') return;
        const label = this.button.querySelector('[data-label]');
        const status = this.querySelector('[data-status]');
        this.button.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        label.textContent = this.dataset.loadingLabel;
        try {
          const response = await fetch(this.button.dataset.nextUrl, { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
          const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextListing = nextDocument.querySelector(`#${this.id}`);
          const nextItems = nextListing?.querySelectorAll('.blog-listing__item');
          if (!nextListing || !nextItems?.length) throw new Error('No more articles found');
          const list = this.querySelector('.blog-listing__items');
          nextItems.forEach((item) => list.append(item));
          const nextButton = nextListing.querySelector('[data-load-more]');
          if (nextButton?.dataset.nextUrl) {
            this.button.dataset.nextUrl = nextButton.dataset.nextUrl;
            this.button.removeAttribute('aria-busy');
            this.button.disabled = false;
            label.textContent = this.dataset.loadMoreLabel;
          } else {
            this.querySelector('.blog-listing__actions')?.remove();
          }
          if (status) status.textContent = this.dataset.loadedLabel;
        } catch (error) {
          this.button.removeAttribute('aria-busy');
          this.button.disabled = false;
          label.textContent = this.dataset.loadMoreLabel;
          if (status) status.textContent = this.dataset.errorLabel;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
